import { HashRouter as Router, Routes, Route } from "react-router-dom";
import MainPage from "../pages/main";
import PersonalLoan from '../pages/personalloan'
import BankLoan from "../pages/businessloan";
import CreditCardOffers from "../pages/creditcard";
import Aboutus from '../pages/about'
import Checkout from "../pages/checkout";

function MyRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/personalloan" element={<PersonalLoan />} />
        <Route path="/businessloan" element={<BankLoan />} />
        <Route path="/creditcard" element={<CreditCardOffers />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/checkout" element={<Checkout />} />
      </Routes>
    </Router>
  );
}

export default MyRoutes;
